/**
 * Retrieves the language setting from local storage.
 *
 * @returns The language setting, either 'en' for English or 'pt' for Portuguese.
 */
export const getLanguageFromLocalStorage = () => {
  const language = localStorage.getItem('i18nextLng');
  if (language === 'en' || language?.startsWith('en-')) {
    return 'en';
  }
  if (language === 'pt' || language?.startsWith('pt-')) {
    return 'pt';
  }
  return 'pt';
};
